import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth, homeFor } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // One-time session exchange — useRef guard prevents double-processing under StrictMode
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homeFor(data.role), { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF8]" data-testid="auth-callback">
      <div className="h-8 w-8 rounded-full border-2 border-[#1E3F20] border-t-transparent animate-spin" />
    </div>
  );
}
